import React from "react";

const UserManualContext = React.createContext(null);

export default UserManualContext;
